const actions = {
  GET_DATA_VEHICLE: 'GET_DATA_VEHICLE',
  SET_DATA_VEHICLE: 'SET_DATA_VEHICLE',
  EDIT_DATA_VEHICLE: 'EDIT_DATA_VEHICLE',
  DELETE_DATA_VEHICLE: 'DELETE_DATA_VEHICLE',
  SET_NEW_DATA_VEHICLE: 'SET_NEW_DATA_VEHICLE',
  GET_DATA_BEGIN: 'GET_DATA_BEGIN',
  GET_DATA_FINISH: 'GET_DATA_FINISH',
  getVehicleData: () => {
    return {
      type: actions.GET_DATA_VEHICLE,
    };
  },
  setVehicleData: (data: any) => {
    return {
      type: actions.SET_DATA_VEHICLE,
      data,
    };
  },
  getDataBegin: () => {
    return {
      type: actions.GET_DATA_BEGIN,
    };
  },
  getDataFinish: () => {
    return {
      type: actions.GET_DATA_FINISH,
    };
  },
  setDeleteVehicle: (data: any) => {
    return {
      type: actions.DELETE_DATA_VEHICLE,
      data,
    };
  },
  setEditVehicleData: (data: any) => {
    return {
      type: actions.EDIT_DATA_VEHICLE,
      data,
    };
  },
  setNewVehicleData: (data: any) => {
    return {
      type: actions.SET_NEW_DATA_VEHICLE,
      data,
    };
  },
};

export default actions;
